import { AppErrorDialog, BeforeUnloadEvent, ErrorBoundary } from 'ui-components'
import { persistor } from '~map-preview/states/store'

const Fallback = () => {
  const handleReload = async () => {
    await persistor.purge()
  }

  const handleBeforeUnload = async () => {
    await handleReload()
  }

  return (
    <BeforeUnloadEvent onHandle={handleBeforeUnload}>
      <AppErrorDialog
        open
        actionText='Reload map'
        onActionClick={handleReload}
      />
    </BeforeUnloadEvent>
  )
}

const error = (Component) => (props) => {
  return (
    <ErrorBoundary fallback={Fallback}>
      <Component {...props} />
    </ErrorBoundary>
  )
}

export { error, Fallback }
